import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  HstProductsWithPlaceholderModules,
  getComingSoonModules,
} from "constants/placeholder-constants";
import type { ComingSoonModules } from "models/product/ProductDetails";

import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useProduct } from "hooks/useProduct";
import { useLanguage } from "hooks/useSelectedLanguage";

// Return data for placeholder modules active for the currently selected product
// and filters specified in ConfigCat variable
export const usePlaceholderModules = (): ComingSoonModules[] => {
  const { t } = useTranslation("homepage");
  const { productDetails } = useProduct();
  const { currentLanguage } = useLanguage();

  const {
    showComingSoonModules,
    hiddenPlaceholderModuleIds: stringifiedHiddenPlaceholderModuleIds,
  } = useFeatureFlags();

  const hiddenPlaceholderModuleIds = (
    (stringifiedHiddenPlaceholderModuleIds as string) || ""
  ).split(",");

  const availablePlaceholderModules = useMemo<ComingSoonModules[]>(
    () =>
      showComingSoonModules &&
      productDetails?.id &&
      HstProductsWithPlaceholderModules.includes(productDetails.id)
        ? getComingSoonModules(t).filter(
            ({ type: placeholderModuleId }) =>
              !hiddenPlaceholderModuleIds.includes(placeholderModuleId),
          )
        : [],
    [currentLanguage, productDetails?.id],
  );

  return availablePlaceholderModules;
};
